
import { createAction, props } from '@ngrx/store';
import { CareerApplicationRequest, CareerApplicationResponse, CareerApplicationsPage } from '../../models/careers.model';

export const uploadResume = createAction(
  '[Careers] Upload Resume',
  props<{ file: File }>()
);

export const uploadResumeSuccess = createAction(
  '[Careers] Upload Resume Success',
  props<{ resumeUrl: string }>()
);

export const uploadResumeFailure = createAction(
  '[Careers] Upload Resume Failure',
  props<{ error: string }>()
);

// Combined action: uploads file then immediately submits using the returned URL
export const uploadResumeAndSubmit = createAction(
  '[Careers] Upload Resume And Submit',
  props<{ file: File; formData: Omit<CareerApplicationRequest, 'ResumeUrl'> }>()
);

export const submitCareerApplication = createAction(
  '[Careers] Submit Application',
  props<{ data: CareerApplicationRequest }>()
);

export const submitCareerApplicationSuccess = createAction(
  '[Careers] Submit Application Success',
  props<{ application: CareerApplicationResponse }>()
);

export const submitCareerApplicationFailure = createAction(
  '[Careers] Submit Application Failure',
  props<{ error: string }>()
);

export const getCareerApplications = createAction(
  '[Careers] Get Applications',
  props<{ pageNumber?: number; pageSize?: number }>()
);

export const getCareerApplicationsSuccess = createAction(
  '[Careers] Get Applications Success',
  props<{ page: CareerApplicationsPage }>()
);

export const getCareerApplicationsFailure = createAction(
  '[Careers] Get Applications Failure',
  props<{ error: string }>()
);

export const getCareerApplicationById = createAction(
  '[Careers] Get Application By Id',
  props<{ id: number }>()
);

export const getCareerApplicationByIdSuccess = createAction(
  '[Careers] Get Application By Id Success',
  props<{ application: CareerApplicationResponse }>()
);

export const getCareerApplicationByIdFailure = createAction(
  '[Careers] Get Application By Id Failure',
  props<{ error: string }>()
);

export const resetCareersState = createAction('[Careers] Reset State');
